import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import {
  DEFAULT_EXPENSE_DATE_BASIS,
  SET_EXPENSE_DATE_BASIS,
} from '../../RTK/Slices/AppConfigSlice';
import { persistor } from '../../RTK/Store/Index';

const DEFAULT_AMOUNT_DIVISOR = '1';

const EXPENSE_DATE_OPTIONS = [
  { value: 'voucher_order_date', label: 'Voucher / Order Date' },
  { value: 'payment_date', label: 'Payment Date' },
  { value: 'ppa_date', label: 'PPA Date' },
];

const SubHeader = ({ fy_list, setDivisionNumber, handlePageTrigger }) => {
    const dispatch = useDispatch();
    const expenseDateBasis = useSelector(
        (state) => state.appConfig?.expenseDateBasis || DEFAULT_EXPENSE_DATE_BASIS
    );
    const [amountDivisor, setAmountDivisor] = useState(DEFAULT_AMOUNT_DIVISOR);

    useEffect(() => {
        const stored = localStorage.getItem('globalAmountDivisor');
        if (stored) {
            setAmountDivisor(stored);
            if (typeof setDivisionNumber === 'function') {
                setDivisionNumber(stored);
            }
        } else {
            localStorage.setItem('globalAmountDivisor', DEFAULT_AMOUNT_DIVISOR);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleFinancialYearChange = async (e) => {
        const val = e.target.value;
        localStorage.setItem("globalDateId", val);
        handlePageTrigger();
    };

    const handleAmountDivisorChange = (e) => {
        const val = String(e.target.value || DEFAULT_AMOUNT_DIVISOR);
        setAmountDivisor(val);
        localStorage.setItem('globalAmountDivisor', val);
        if (typeof setDivisionNumber === 'function') {
            setDivisionNumber(val);
        }
        window.dispatchEvent(new Event('amount_divisor_changed'));
    };

    const handleExpenseDateBasisChange = async (e) => {
        const val = e.target.value || DEFAULT_EXPENSE_DATE_BASIS;
        if (val === expenseDateBasis) {
            return;
        }
        dispatch(SET_EXPENSE_DATE_BASIS(val));
        await persistor.flush();
        window.location.reload();
    };

    const fyId = localStorage.getItem('globalDateId');
    return (
        <div className="budget_analysis border position-relative" style={{backgroundColor: '#fff', padding: '10px 16px'}}>
        <h1 className='p-0 m-0'>Financial Year</h1>
        <div className="d-flex gap-8px justify-content-start align-items-center" style={{width:"13%"}} >
            <select 
            id="financial_year"
            name="financial_year_id"
            onChange={handleFinancialYearChange}
            style={{ width: "100%" }}
            >
                <option value="">---select year---</option>
                {fy_list.map((fy) => {
                    const currentMonth = moment().month() + 1;
                    const selectedYear = (!fyId) ? (currentMonth >= 4 ? fy.start_year : fy.end_year) : fyId;
                    const isSelected = Number(fyId) === Number(fy.id) || selectedYear === moment().format("YYYY");
                    return (
                        <option
                            value={fy.id}
                            key={fy.id}
                            selected={isSelected}
                        >
                            {fy.year}
                        </option>
                    );
                })}
            </select>
        </div>

        <div className='position-absolute end-0 pe-3 translate-50 fs-12px d-flex align-items-center gap-3'>
            <p className='m-0'>
                <strong>Expense based on</strong>
                <select
                    name="expense_date_basis"
                    id="expense_date_basis"
                    style={{ width: 'fit-content' }}
                    className='bg-transparent border-0 text-prime-100'
                    value={expenseDateBasis}
                    onChange={handleExpenseDateBasisChange}
                >
                    {EXPENSE_DATE_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </p>
            <p className='m-0'>
                <strong>All value in Indian</strong>
                <select
                    name="rupe"
                    id="rupe"
                    style={{ width: "fit-content" }}
                    className='bg-transparent border-0 text-prime-100'
                    value={amountDivisor}
                    onChange={handleAmountDivisorChange}
                    disabled={false}
                >
                  <option value="1"> Rupees</option>
                  <option value="1000"> Thousands Rupees </option>
                  <option value="100000"> Lakhs Rupees </option>
                  <option value="10000000"> Crores Rupees </option>
                </select>
            </p>
        </div>
        </div>
    )
}

export default SubHeader;
